/**
 * @file app/loading.tsx
 * @description Global loading UI for BikeParkMapa
 * @module app/loading
 * @note Shown during server-side navigation between routes
 */
'use client';

export default function Loading() {
  return (
    <div className="content-page">
      <div className="loading-container" style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
      }}>
        {/* Animated bike icon */}
        <div style={{
          fontSize: '4rem',
          marginBottom: '2rem',
          animation: 'bounce 1s ease-in-out infinite',
        }}>
          🚵
        </div>

        {/* Loading text */}
        <h2 style={{
          fontSize: '1.5rem',
          marginBottom: '1rem',
          color: 'var(--primary-color, #16a34a)',
        }}>
          Ładowanie...
        </h2>

        {/* Loading spinner */}
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(22, 163, 74, 0.1)',
          borderTop: '4px solid var(--primary-color, #16a34a)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}></div>

        {/* CSS animations */}
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-20px);
            }
          }
        `}</style>
      </div>
    </div>
  );
}
